import {
  blocksOptionsConfig,
  newCollectionTemplate,
} from "@components/cmsBlocks/configs";
export const typeSlider = blocksOptionsConfig.collectionTypes.sliderV7.value;

export const sliderConfig = newCollectionTemplate({
  typeFields: {
    alt: "text",
    image: "image",
    isShow: "boolean",
  },
  itemTemplate: {
    alt: "",
    image: "",
    isShow: true,
  },
  type: typeSlider,
  allowUseSet: false,
  showAsTitle: "alt", // only texts fields
});

// export const sliderConfig1 = {
//   typeFields: {
//     alt: "text",
//     image: "image",
//   },
//   itemTemplate: {
//     alt: "",
//     image: "",
//   },
//   type: typeSlider,
//   allowUseSet: false,
//   showAsTitle: "alt", // only texts fields
// };

export const initBlockData = {
  title: "",
  collections: {
    [typeSlider]: {
      ...sliderConfig,
      items: [],
    },
  },
};
export const initEmptyBlockData = {
  title: "",
  collections: {
    [typeSlider]: {
      ...sliderConfig,
      items: [],
    },
  },
};
